/**
 * Everpret Premium PLP -- variant thumbnail -> card state sync.
 *
 * Only loaded by sections/main-collection-everpret.liquid (templates/collection.everpret-premium.json).
 * Never loaded globally, so no other collection/card pays for this.
 *
 * What this does, and why it's the only new JS this template needs:
 *   - Keeps the card's hidden add-to-cart "id" field in sync with whichever variant thumbnail
 *     is selected. Submission itself still goes through the theme's existing <product-form>
 *     web component (assets/theme.js) -- fetch to cart/add.js, cart drawer refresh, no reload,
 *     no redirect -- none of that is reimplemented here.
 *   - Swaps the card image and price/compare-at text to match the selected variant.
 *   - Hover preview on desktop (mirrors click selection, but non-committing).
 *
 * Single delegated listener set, bound once (idempotent guard below), so this keeps working
 * for cards injected later by the theme's own facet/pagination AJAX re-renders without ever
 * attaching a second set of listeners.
 */
(function () {
  if (window.everpretPlpBound) {
    return;
  }
  window.everpretPlpBound = true;

  function swapImage(card, src) {
    var img = card.querySelector(".ev-card__image--primary");
    if (!img || !src || img.src === src) {
      return;
    }

    img.style.transition = "opacity .15s ease";
    img.style.opacity = "0";

    var preload = new Image();
    preload.onload = function () {
      img.src = src;
      img.style.opacity = "1";
    };
    preload.src = src;
  }

  function setTrailingText(el, text) {
    if (!el || typeof text !== "string" || text === "") {
      return;
    }

    var node = el.lastChild;
    if (node && node.nodeType === Node.TEXT_NODE) {
      node.textContent = text;
    } else {
      el.appendChild(document.createTextNode(text));
    }
  }

  function commitVariant(card, input) {
    var idField = card.querySelector("[data-ev-variant-id-input]");
    var variantId = input.getAttribute("data-variant-id");
    if (idField && variantId) {
      idField.value = variantId;
    }

    swapImage(card, input.getAttribute("data-variant-image"));
    setTrailingText(card.querySelector(".price-list sale-price"), input.getAttribute("data-variant-price"));

    var compareEl = card.querySelector(".price-list compare-at-price");
    var comparePrice = input.getAttribute("data-variant-compare-at-price");
    if (compareEl) {
      if (comparePrice) {
        compareEl.hidden = false;
        setTrailingText(compareEl, comparePrice);
      } else {
        compareEl.hidden = true;
      }
    }

  }

  document.addEventListener("change", function (event) {
    var input = event.target.closest(".everpret-plp .ev-vthumbs input[type=\"radio\"]");
    if (!input) {
      return;
    }

    var card = input.closest(".ev-card");
    if (card) {
      commitVariant(card, input);
    }
  });

  document.addEventListener(
    "pointerover",
    function (event) {
      var label = event.target.closest(".everpret-plp .ev-vthumbs .thumbnail-swatch");
      if (!label) {
        return;
      }

      var input = document.getElementById(label.getAttribute("for"));
      var card = label.closest(".ev-card");
      if (input && card) {
        swapImage(card, input.getAttribute("data-variant-image"));
      }
    },
    true
  );

  document.addEventListener(
    "pointerout",
    function (event) {
      var label = event.target.closest(".everpret-plp .ev-vthumbs .thumbnail-swatch");
      if (!label) {
        return;
      }

      var card = label.closest(".ev-card");
      if (!card) {
        return;
      }

      var checked = card.querySelector('.ev-vthumbs input[type="radio"]:checked');
      if (checked) {
        swapImage(card, checked.getAttribute("data-variant-image"));
      }
    },
    true
  );
})();
